import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../styles/SolicitudesPendientes.css";
import useProveedores from "../hooks/useProveedores";
import useDropdownData from "../hooks/useDropdownData";
import Spinner from "./Spinner";
import {
  formatearFechaPlano,
  obtenerDescripcion,
  obtenerEmpresa,
  urlApi,
} from "../helpers/functionHelpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faTruck } from "@fortawesome/free-solid-svg-icons";
import useEmpresaStore from "../context/empresaStore";

const SolicitudesPendientes = () => {
  const { empresa_id, setEmpresaId } = useEmpresaStore();
  const { folio } = useParams();
  
  // Estados para OCs múltiples
  const [ocList, setOcList] = useState([]);
  const [ocSeleccionada, setOcSeleccionada] = useState(0);
  
  const [almacen, setAlmacen] = useState({
    id: '',
    ubicacion: '',
    descripcion: ''
  });
  const [prvData, setPrvData] = useState({
    nombrePrv: "",
    correoPrv: "",
    telefonoPrv: "",
    compania: "",
    fechaRsv: "",
    almacen_id: "",
    numeroOC: "",
    numFac: "",
    nmInsumo: "",
    cantidad: "",
    numeroCntdr: "",
    pesoOcantidad: "",
    numeroPallets: "",
    undmdas_id: "",
    undmdas_descripcion: "",
    containers_id: "",
    containers_descripcion: "",
    conditions_id: "",
    conditions_descripcion: "",
    comentariosPrv: "",
    statuses_id: "",
    empresa_id: "",
    folio: "",
    extras: {},
    transportista: {
      cab_id: "",
      nameOpr: "",
      telefonoOpr: "",
      vehiculo_id: "",
      vehiculo_descripcion: "",
      placa: "",
      numOprUdad: "",
      personalAdcnl: "",
      cometariosTrp: "",
      correoTrp: "",
      created_at: "",
    },
  });
  const {
    proveedores: dataProveedores,
    loading: loadingProveedores,
    error: errorProveedores,
  } = useProveedores(`${urlApi}/api/proveedores/${folio}`);
  const {
    proveedores: dataTransportista,
    loading: loadingTransportistas,
    error: errorTransportistas,
  } = useProveedores(`${urlApi}/api/transportista/${folio}`);
  const { data: unidades, loading: loadingUnidades } = useDropdownData(`${urlApi}/api/unidades`, setPrvData, prvData.undmdas_id, true);
  const { data: contenedores, loading: loadingContenedores } = useDropdownData(`${urlApi}/api/contenedores`);
  const { data: condiciones, loading: loadingCondiciones } = useDropdownData(`${urlApi}/api/condiciones`);
  const { data: vehiculos, loading: loadingVehiculos, error: errorVehiculos } = useDropdownData(`${urlApi}/api/vehiculos`, setPrvData, prvData.transportista.vehiculo_id, true);
  const { data: statuses, loading: loadingStatus, error: errorStatus } = useDropdownData(`${urlApi}/api/statuses`);
  const { data: ubicacions } = useDropdownData(`${urlApi}/api/ubicacions`, setAlmacen, almacen.id, true);


  const { data: empresa, loading: loadingEmpresa } = useDropdownData(
    `${urlApi}/api/empresas`
  );

  const obtenerName = (id, lista) => {
    const item = lista.find((element) => element.id === id);
    return item ? item.name : "No disponible";
  };

  const cargarProveedor = (dataProveedoresArray, dataTransportista) => {
    // Soportar tanto arrays como objetos (para compatibilidad)
    const proveedoresArray = Array.isArray(dataProveedoresArray) ? dataProveedoresArray : [dataProveedoresArray];
    const transportistaData = Array.isArray(dataTransportista)
      ? (dataTransportista[0] || {})
      : (dataTransportista || {});
    
    if (proveedoresArray.length === 0) return;
    
    setOcList(proveedoresArray);
    setOcSeleccionada(0);
    
    // Cargar el primer proveedor
    const dataProveedores = proveedoresArray[0];
    const extras = {};
    if (dataProveedores.empresa_id === 4 && dataProveedores.extras && dataProveedores.extras.campo_nombre === 'probiomedInterna') {
      extras.probiomedInterna = dataProveedores.extras.campo_valor;
    }

    if (dataProveedores.empresa_id === 3 && dataProveedores.extras && dataProveedores.extras.campo_nombre === 'materialSanfer') {
      extras.materialSanfer = dataProveedores.extras.campo_valor;
    }
    setPrvData((prevState) => ({
      ...prevState,
      ...dataProveedores,
      extras,
      transportista: {
        ...prevState.transportista,
        ...transportistaData,
      },
    }));
  };

  // Manejar cambio de OC seleccionada
  const handleCambiarOC = (index) => {
    setOcSeleccionada(index);
    const ocSeleccionadaData = ocList[index];
    
    const extras = {};
    if (ocSeleccionadaData.empresa_id === 4 && ocSeleccionadaData.extras && ocSeleccionadaData.extras.campo_nombre === 'probiomedInterna') {
      extras.probiomedInterna = ocSeleccionadaData.extras.campo_valor;
    }

    if (ocSeleccionadaData.empresa_id === 3 && ocSeleccionadaData.extras && ocSeleccionadaData.extras.campo_nombre === 'materialSanfer') {
      extras.materialSanfer = ocSeleccionadaData.extras.campo_valor;
    }

    setPrvData((prevState) => ({
      ...prevState,
      ...ocSeleccionadaData,
      extras,
    }));
  };

  useEffect(() => {
    if (dataProveedores && dataTransportista) {
      cargarProveedor(dataProveedores, dataTransportista);
    }
    if (!empresa_id && dataProveedores) {
      const proveedoresArray = Array.isArray(dataProveedores) ? dataProveedores : [dataProveedores];
      if (proveedoresArray.length > 0) {
        setEmpresaId(proveedoresArray[0].empresa_id);
      }
    }
  }, [dataProveedores, dataTransportista, empresa_id, setEmpresaId]);

  useEffect(() => {
  obtenerDescripcion(prvData.extras.probiomedInterna, ubicacions)
}, [prvData.extras.probiomedInterna, ubicacions]);

  const loading =
    loadingProveedores ||
    loadingTransportistas ||
    loadingVehiculos ||
    loadingUnidades ||
    loadingContenedores ||
    loadingCondiciones ||
    loadingStatus ||
    loadingEmpresa;
  const error =
    errorProveedores || errorTransportistas || errorVehiculos || errorStatus;

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner-wrapper">
          <Spinner />
          <p className="loading-text">Cargando datos...</p>
        </div>
      </div>
    );
  }

  // Mostrar mensaje de error si ocurrió un error en alguna carga
  if (error) {
    return <p>Error al cargar datos: {error}</p>;
  }

  return (
    <div className="solicitudes-container">
      <div className="solicitudes-list">
        {/* SELECTOR DE OCs */}
        {ocList.length > 1 && (
          <div style={{ marginBottom: "20px", padding: "15px", background: "#f5f5f5", borderRadius: "8px" }}>
            <h3 style={{ marginTop: 0 }}>Selecciona una OC para editar:</h3>
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              {ocList.map((oc, index) => (
                <button
                  key={index}
                  onClick={() => handleCambiarOC(index)}
                  style={{
                    padding: "10px 15px",
                    background: ocSeleccionada === index ? "#2196F3" : "white",
                    color: ocSeleccionada === index ? "white" : "black",
                    border: ocSeleccionada === index ? "2px solid #2196F3" : "2px solid #ddd",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    transition: "all 0.3s"
                  }}
                >
                  <div>OC #{index + 1}: {oc.numeroOC}</div>
                  <div style={{ fontSize: "12px", fontWeight: "normal", marginTop: "4px", opacity: 0.8 }}>
                    {oc.nmInsumo}
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}

        <div key={prvData.folio} className="solicitud-card">
          <div className="solicitud-details">
            <div className="solicitud-section">
              <h2>
                <FontAwesomeIcon
                  icon={faBuilding}
                  style={{ marginRight: "8px", color: "#d32f2f" }}
                />
                Datos Proveedor {ocList.length > 1 && `(OC #${ocSeleccionada + 1})`}
              </h2>
              <p>
                <strong>Fecha de creación: </strong>
                {new Date(prvData.transportista.created_at).toLocaleString()}
              </p>
              <p>
                <strong>Fecha deseada: </strong>
                {formatearFechaPlano(prvData.fechaRsv)}
              </p>
              <p>
                <strong>Compañía: </strong> {prvData.compania}
              </p>
              <p>
                <strong>Nombre: </strong> {prvData.nombrePrv}
              </p>
              <p>
                <strong>Correo: </strong> {prvData.correoPrv}
              </p>
              <p>
                <strong>Número de OC: </strong> {prvData.numeroOC}
              </p>
              <p>
                <strong>Número de factura: </strong> {prvData.numFac}
              </p>
              <p>
                <strong>Nombre del insumo: </strong> {prvData.nmInsumo}
              </p>
              <p>
                <strong>Cantidad a recibir: </strong> {prvData.cantidad}
              </p>
              <p>
                <strong>Unidad de medida: </strong>{" "}
                {prvData?.undmdas_id
                  ? obtenerDescripcion(prvData?.undmdas_id, unidades)
                  : "No disponible"}
              </p>
              <p>
                <strong>Tipo de contenedor: </strong>{" "}
                {prvData?.containers_id
                  ? obtenerDescripcion(prvData?.containers_id, contenedores)
                  : "No disponible"}
              </p>
              <p>
                <strong>Número de contenedores: </strong> {prvData.numeroCntdr}
              </p>
              <p>
                <strong>Número de pallets: </strong> {prvData.numeroPallets}
              </p>
              <p>
                <strong>Condiciones de transporte: </strong>{" "}
                {prvData?.conditions_id
                  ? obtenerDescripcion(prvData?.conditions_id, condiciones)
                  : "No disponible"}
              </p>
              <p>
                <strong>Teléfono: </strong> {prvData.telefonoPrv}
              </p>
              <p>
                <strong>Estatus: </strong>
                {obtenerName(prvData.statuses_id, statuses)}
              </p>
              <p>
                <strong>Empresa: </strong>
                {obtenerEmpresa(prvData.empresa_id, empresa)}
              </p>

              {prvData.extras?.materialSanfer && (
                <p>
                  <strong>Código de material Sanfer:</strong> {prvData.extras.materialSanfer}
                </p>
              )}
              {prvData.extras?.probiomedInterna && (
                <p>
                  <strong>Almacén:</strong> {obtenerDescripcion(prvData.extras.probiomedInterna, ubicacions)}
                </p>
              )}

              <p>
                <strong>Comentarios: </strong> {prvData.comentariosPrv}
              </p>
            </div>
            <div className="solicitud-section">
              <h2>
                <FontAwesomeIcon
                  icon={faTruck}
                  style={{ marginRight: "8px", color: "#d32f2f" }}
                />
                Datos Transportista
              </h2>
              <p>
                <strong>Nombre:</strong> {prvData.transportista.nameOpr}
              </p>
              <p>
                <strong>Teléfono:</strong> {prvData.transportista.telefonoOpr}
              </p>
              <p>
                <strong>Correo:</strong> {prvData.transportista.correoTrp}
              </p>
              <p>
                <strong>Unidad:</strong>{" "}
                {prvData?.transportista.vehiculo_id
                  ? obtenerDescripcion(
                    prvData?.transportista.vehiculo_id,
                    vehiculos
                  )
                  : "No disponible"}
              </p>
              <p>
                <strong>Placa:</strong> {prvData.transportista.placa}
              </p>
              <p>
                <strong>Número de operarios:</strong>{" "}
                {prvData.transportista.numOprUdad}
              </p>
              <p>
                <strong>Personal adicional:</strong>{" "}
                {prvData.transportista.personalAdcnl}
              </p>
              <p>
                <strong>Comentarios:</strong>{" "}
                {prvData.transportista.cometariosTrp}
              </p>
            </div>
          </div>
          <h4>Folio: {prvData.folio}</h4>
        </div>
      </div>
    </div>
  );
};

export default SolicitudesPendientes;
